/**
 * State of the training gate shown in the object details panel.
 * - READY:    the summary says a child object can be trained.
 * - LOCKED:   the summary says not yet — counts short, or nothing new since the
 *             last training; the user must annotate first.
 * - UNKNOWN:  the annotation summary has not loaded (or failed), so there are no
 *             counts or thresholds to judge by.
 */
export const TRAINING_GATE = Object.freeze({
	READY: 'ready',
	LOCKED: 'locked',
	UNKNOWN: 'unknown',
});
